import React, { useMemo, useState } from "react";
import axios from "axios";
import { ImageUploadModal } from "../../components/modals";
import { verificationConstant } from "../../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faWarning } from "@fortawesome/free-solid-svg-icons";
import { isMobile } from "react-device-detect";
import { getFileUrl } from "../../core/config/api.js";

const VerificationItem = ({
  user,
  id,
  file,
  // Signed capability URL for FileAccessPolicy-gated files (the ID document).
  // Browser-native loads (background-image, window.open) carry no auth header,
  // so the bare /api/files/{id} 403s on gated files — prefer the signed URL.
  fileUrl,
  onSave,
  isAcceptable = false,
  afterSubmit,
  isVerified,
}) => {
  const [open, setOpen] = useState(false);
  const src = fileUrl ?? (file ? getFileUrl(file) : null);

  const onSetFile = (file) => {
    onSave(file.id);
    setOpen(false);
  };

  const onVerify = async (status) => {
    const { data } = await axios.put(`/api/users/${user.id}/verify-id`, {
      status,
    });
    afterSubmit(data);
  };

  const onProfileRequest = async () => {
    const { data } = await axios.get(`/api/users/${user.id}/request-profile`);
    afterSubmit(data);
  };

  return (
    <div className={`${isMobile} ? 'col-12' 'col-6 col-lg-6  col-md-12'`}>
      <div className="card">
        <div className="mb-2 d-flex justify-content-between align-items-center">
          <h3>{verificationConstant[id].title}</h3>
          {isVerified && (
            <FontAwesomeIcon
              icon={faCheckCircle}
              className="text-success"
              size="xl"
            />
          )}
          {!isVerified && (
            <FontAwesomeIcon
              icon={faWarning}
              className="text-warning"
              size="xl"
            />
          )}
        </div>

        {file && (
          <div>
            <div className="rug-item">
              <div className="rug-card">
                <div
                  className="rug-card-image"
                  style={{
                    backgroundImage: `url("${src}")`,
                  }}
                  onClick={() => window.open(src, "_blank")}
                ></div>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <button className="mr-2" onClick={() => setOpen(true)}>
                Replace
              </button>
              {isAcceptable && !user.is_id_verified && (
                <>
                  <button
                    className="mr-2 bg-danger"
                    onClick={() => onVerify(false)}
                  >
                    Decline
                  </button>
                  <button
                    className="mr-2 bg-success"
                    onClick={() => onVerify(true)}
                  >
                    Accept
                  </button>
                </>
              )}
            </div>
          </div>
        )}

        {!file && (
          <div>
            <p className="mb-3">There is no uploaded file.</p>
            <div className="d-flex justify-content-end">
              {!isAcceptable && (
                <button className="mr-2" onClick={() => onProfileRequest()}>
                  Request Upload
                </button>
              )}
              <button className="mr-2" onClick={() => setOpen(true)}>
                Upload
              </button>
            </div>
          </div>
        )}

        <ImageUploadModal
          defaultSrc={src}
          open={open}
          onSetFile={onSetFile}
          closeModal={() => setOpen(false)}
          modalProps={{ title: verificationConstant[id].modalProps.title }}
        />
      </div>
    </div>
  );
};

export default VerificationItem;
